export const SET_POCKET_DATA = "SET_POCKET_DATA"
export const SET_POCKET_DETAILS = "SET_POCKET_DETAILS"
export const CREATE_SUB_POCKET = "CREATE_SUB_POCKET"
export const CLEAR_NEW_SUB_POCKET_DATA = "CLEAR_NEW_SUB_POCKET_DATA"
export const SET_ACCOUNT_INFO = "SET_ACCOUNT_INFO"
export const SET_DASHBOARD_ANALYTICS = "SET_DASHBOARD_ANALYTICS"
export const SET_ALL_POCKET_DETAILS = "SET_ALL_POCKET_DETAILS"